import { Input } from '@popsure/dirty-swan';
import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '../../../models';
import { useEffect, useState } from 'react';

import { Header } from '../../Screen';

export type NumberInputFormProps<Questionnaire extends QuestionnaireQuestions> =
  {
    validate?: (value: number) => boolean;
    prefix?: string;
    min? : number;
    max? : number;
  } & QuestionnaireFormProps<Questionnaire, number>;

export const NumberInputForm = <Questionnaire extends QuestionnaireQuestions>({
  value,
  question,
  onSubmitValue,
  featureName,
  placeholder,
  validate,
  setValidForSubmission,
  prefix,
  min,
  max,
}: NumberInputFormProps<Questionnaire>) => {
  const [number, setNumber] = useState<string>(value ? String(value) : '');

  const handleSubmit = () => {
    if (!number) {
      throw new Error(
        `[${featureName}] Number value is missing for submission for question: ${question}`
      );
    }
    onSubmitValue(Number(number));
  };

  useEffect(() => {
    const isValid = number && (validate ? validate(parseFloat(number)) : true);
    setValidForSubmission(Boolean(isValid));
  }, [number, setValidForSubmission, validate]);

  return (
    <Header onSubmit={handleSubmit}>
      <Input
        placeholder={placeholder}
        onChange={(e) => setNumber(e.target.value)}
        type="number"
        value={number}
        pattern="[0-9]*"
        prefix={prefix}
        min={min}
        max={max}
      />
    </Header>
  );
};
